import {
  IKontoplan,
  getKontoplanFnType,
  IKontodelDef,
  IKontodel,
  IKontodelTillaggsinfo,
} from './Query/KonteringManagerQuery';
import { IKodstrang, IKonteringValidationError } from './KonteringManager';
import {
  TEDEKKontodelkombinationKOMBINATIONEnum,
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRFakturaAttestSTATUSEnum,
} from '../../../../../globalQueryTypes';
import {
  isKoddelInKodbeh,
  UrvalErrorEnum,
} from '../../../Ekonomi/Rutiner/EkonomiskAnalys/Components/SideMenu/Components/UrvalOchSummering/Components/Urval/Utils/UrvalUtils';
import { IAttestKodbehorighetUrval } from './KonteringContext';
import {
  createTemplateWholeBookKodbeh,
  findKodbehWithHighestMaxbelopp,
  roundToTwoDecimals,
} from '../../../Leverantor/ObjektVyer/FakturaDel/Components/Kontering/Utils/KonteringUtils';
import {
  KonteringManagerQuery_db_EKKonteringsvarde_All,
  KonteringManagerQuery_db_EKKontodelkombination_All,
  KonteringManagerQuery_rtn_EKKodplan__Associations_Kontodelsdef_All__Associations_Kontodel_All__Associations_Enhet,
} from './Query/_QueryTypes/KonteringManagerQuery';
import { uniq } from 'ramda';
import { kontostrangInSelection } from '../../Utils/kodbehorighetUtils';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
} from '../../../Leverantor/ObjektVyer/FakturaDel/Queries/_QueryTypes/FakturaDelQuery';
import { IFieldValidation } from '../BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  getKontodelByIDInKontodelsdef,
  getKontodelByKontodelsdef,
  isVisibleByKontodelDate,
  kombinationsVillkorValidation,
  kombinationValidation,
  kontodelValidation,
} from './validateKonteringForAttestUtils';
import { IAktuellFakturaAttestInfo } from '../../../Leverantor/ObjektVyer/FakturaDel/Utils/FakturadelUtils';
import { BELOPP_FIELD_NAME } from '../../../Leverantor/ObjektVyer/FakturaDel/Components/Kontering/KonteringsForslagComp';
import { findFormatter } from '../../../../../Utils/Formatters/FindFormatter';
import { AUTOMATICALLY_ADDED_VALUE_PREFIX } from '../../../Leverantor/ObjektVyer/FakturaDel/Components/FakturaDelContextManager/FakturaDelContextManager';

export interface ICorrectnessKodbeh {
  kodbehoriget: IAttestKodbehorighetUrval;
  correctnessCount: number;
}
export interface IFilteredKodbehForKonteringsForslag {
  fakturaID: string;
  konteringsforslagID: string;
  attestkodbehorigheter: IAttestKodbehorighetUrval[];
  correctnessKodbeh: IAttestKodbehorighetUrval[];
}

interface IMomspliktig {
  isMomspliktig: boolean;
  avdragsratt: number | null;
}

export type GetKontodelTillaggsinfoType = (
  kontoplanId: string,
  baskontoKontodelId: string
) => IKontodelTillaggsinfo | null;

export interface IAntalredovisning {
  usesAntal: boolean;
  unit:
    | KonteringManagerQuery_rtn_EKKodplan__Associations_Kontodelsdef_All__Associations_Kontodel_All__Associations_Enhet
    | null
    | undefined;
}

export class KonteringUtils {
  private kontoplaner: IKontoplan[];
  private getKontoplan: getKontoplanFnType;

  private dbName: string;
  private konteringsvarden: KonteringManagerQuery_db_EKKonteringsvarde_All[];
  private kontodelkombinationer: KonteringManagerQuery_db_EKKontodelkombination_All[];

  private konteringsForslagWithKodbeh: IFilteredKodbehForKonteringsForslag[];

  constructor(
    kontoplaner: IKontoplan[],
    getKontoplan: getKontoplanFnType,
    dbName: string,
    konteringsvarden: KonteringManagerQuery_db_EKKonteringsvarde_All[],
    kontodelkombinationer: KonteringManagerQuery_db_EKKontodelkombination_All[]
  ) {
    this.kontoplaner = kontoplaner;
    this.getKontoplan = getKontoplan;
    this.dbName = dbName;
    this.konteringsvarden = konteringsvarden;
    this.kontodelkombinationer = kontodelkombinationer;
    this.konteringsForslagWithKodbeh = [];
  }

  setKonteringsForslagWithKodbeh = (
    konteringsforslagId: string,
    attestkodbehorigheter: IAttestKodbehorighetUrval[],
    correctnessObject: IAttestKodbehorighetUrval[],
    fakturaID: string
  ) => {
    const konteringsforslagForKodstrang = this.konteringsForslagWithKodbeh.find(
      konteringsForslag => {
        return konteringsForslag.konteringsforslagID === konteringsforslagId;
      }
    );

    //Filtrera bort konteringsForslagWithKodbeh från andra fakturor
    this.konteringsForslagWithKodbeh = this.konteringsForslagWithKodbeh.filter(
      kodbeh => {
        return kodbeh.fakturaID === fakturaID;
      }
    );

    if (konteringsforslagForKodstrang === undefined) {
      const newEntry: IFilteredKodbehForKonteringsForslag = {
        konteringsforslagID: konteringsforslagId,
        attestkodbehorigheter: attestkodbehorigheter,
        correctnessKodbeh: correctnessObject,
        fakturaID: fakturaID,
      };
      this.konteringsForslagWithKodbeh.push(newEntry);
    } else {
      konteringsforslagForKodstrang.attestkodbehorigheter =
        attestkodbehorigheter;

      konteringsforslagForKodstrang.correctnessKodbeh = correctnessObject;
    }
  };

  getKonteringsForslagWithKodbeh = () => {
    return this.konteringsForslagWithKodbeh;
  };

  getKontodelarByOrdningsNr = (
    kontoplanId: string,
    ordningsNr: number,
    date: Date
  ): IKontodel[] => {
    return (
      this.getKontodelDefByOrdningsNr(
        kontoplanId,
        ordningsNr
      )?.kontodelar.filter(kd => isVisibleByKontodelDate(kd, date)) ?? []
    );
  };

  getKontodelDefByOrdningsNr = (
    kontoplanId: string,
    ordningsNr: number
  ): IKontodelDef | null => {
    return (
      this.getKontodelDefsByKodplanId(kontoplanId).find(
        kddef => kddef.ordningsNr === ordningsNr
      ) ?? null
    );
  };

  fetchAndGetKontoplanIfNotRead = (kontoplanId: string) => {
    const kontoplan =
      this.kontoplaner.find(kplan => kplan.id === kontoplanId) ?? null;
    if (kontoplan?.dataReadTime == null && this.dbName) {
      this.getKontoplan({
        variables: {
          kodplanId: kontoplanId,
          dbName: this.dbName,
        },
      });
    }

    return kontoplan;
  };

  getKontoPlanById = (id: string) => {
    return this.fetchAndGetKontoplanIfNotRead(id);
  };

  getKontodelDefsByKodplanId = (kodplanId: string) => {
    return this.getKontoPlanById(kodplanId)?.kontodelDefs ?? [];
  };

  isKontodelAValidAttestKontodelWithoutKodbeh = (
    kontodel: IKontodel,
    bokfDate: Date,
    sysMomsBaskonto: string | null
  ) => {
    return (
      isVisibleByKontodelDate(kontodel, bokfDate) &&
      !kontodel.sparrAttest &&
      !kontodel.rubrikKonto &&
      !kontodel.budgetKonto &&
      kontodel.aktiv &&
      kontodel.kontodel !== sysMomsBaskonto
    );
  };

  //TODO: Skicka in alternativa kodbehörighet array
  getActiveAttestKontodelDefsByKodplanId = (
    kodplanId: string,
    bokfDate: Date,
    attestKodbehUrval: IAttestKodbehorighetUrval[] | undefined,
    sysMomsBaskonto: string | null,
    isKobfaktura: boolean | null
  ) => {
    const kodplan = this.getKontoPlanById(kodplanId);

    const activeKonton: IKontodelDef[] =
      kodplan?.kontodelDefs.map(kontodelDef => {
        return {
          ...kontodelDef,
          kontodelar: kontodelDef.kontodelar.filter(kontodel => {
            return (
              isVisibleByKontodelDate(kontodel, bokfDate) &&
              !kontodel.sparrAttest &&
              !kontodel.rubrikKonto &&
              !kontodel.budgetKonto &&
              kontodel.aktiv &&
              isKoddelInKodbeh(kontodel, attestKodbehUrval ?? []) &&
              kontodel.kontodel != sysMomsBaskonto
            );
          }),
        };
      }) ?? [];

    return activeKonton;
  };

  getKontodelByKontodel = (
    kodplanId: string,
    ordningsNr: number,
    kontodel: string,
    date: Date
  ) => {
    const kontodelDefs = this.getKontodelDefsByKodplanId(kodplanId);
    return getKontodelByKontodelsdef(kontodelDefs, ordningsNr, kontodel, date);
  };

  getKontodelByKontodelID = (
    kodplanId: string,
    ordningsNr: number,
    kontodelID: string,
    date: Date
  ) => {
    const kontodelDefs = this.getKontodelDefsByKodplanId(kodplanId);
    return getKontodelByIDInKontodelsdef(
      kontodelDefs,
      ordningsNr,
      kontodelID,
      date
    );
  };

  validateKonteringForAttest = (
    kontoplanId: string,
    kodstrang: IKodstrang,
    datum: Date,
    attestTyp: TEDLRFakturaAttestAttestTypEnum,
    konteratBelopp: number,
    fakturaBelopp: number,
    validateAll: boolean,
    iAmBeslutsattestant: boolean,
    konteringsforslagWithKodBeh: IFilteredKodbehForKonteringsForslag[],
    myKonteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[],
    othersKonteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[],
    otherBeslutAttestanter: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[],
    requireMotKodbeh: boolean,
    minFakturaAttest: IAktuellFakturaAttestInfo
  ): IKonteringValidationError[] => {
    const kontoplan = this.getKontoPlanById(kontoplanId);
    if (!kontoplan) {
      return [
        {
          kontodel: '',
          lopnr: -1,
          meddelande: 'Kodplan läses in',
          type: 'Error',
        },
      ];
    }
    let errors: IKonteringValidationError[] = [];
    const isMottagningsAttestant =
      attestTyp === TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST;

    // Kontrollera så att allt som är skrivet finns i kodplanen
    errors = errors.concat(this.checkKontoplan(kodstrang));
    if (errors.length > 0) {
      return errors;
    }

    // Kombination
    if (
      validateAll &&
      (attestTyp === TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST ||
        isMottagningsAttestant)
    ) {
      errors = errors.concat(
        this.getKombinationErrors(
          kodstrang,
          kontoplan,
          datum,
          isMottagningsAttestant
        )
      );
    }

    // Kombinationvillkor
    if (validateAll) {
      errors = errors.concat(
        this.getKombinationsVillkorsErrors(
          kodstrang,
          kontoplan,
          datum,
          isMottagningsAttestant
        )
      );
    }

    if (validateAll) {
      errors = errors.concat(
        this.getKontodelErrors(kodstrang, kontoplan, datum, false)
      );
    }

    // Inom kodbehörighet
    if (
      validateAll &&
      (iAmBeslutsattestant ||
        attestTyp !== TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST) &&
      kodstrang.kontodelar.length !== 0
    ) {
      errors = errors.concat(
        this.getKodbehErrors(
          kontoplan,
          kodstrang,
          konteringsforslagWithKodBeh,
          isMottagningsAttestant,
          requireMotKodbeh,
          minFakturaAttest
        )
      );
    }

    // Hela beloppet attesterat
    if (validateAll) {
      errors = errors.concat(
        this.getBeloppErrors(
          konteratBelopp,
          roundToTwoDecimals(fakturaBelopp),
          kodstrang,
          isMottagningsAttestant
        )
      );
    }

    // Kolla så att det finns fler konteringsrader kvar om det finns kvar beslutattestanter som inte har attesterat
    // och att beslutattestanten tar en konteringsrad

    if (attestTyp === TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST) {
      errors = errors.concat(
        this.getMoreKonteringsraderErrors(
          otherBeslutAttestanter,
          myKonteringsForslag,
          othersKonteringsForslag,
          fakturaBelopp
        )
      );
    }

    return errors;
  };

  getKontodelTillaggsinfo: GetKontodelTillaggsinfoType = (
    kontoplanId,
    baskontoKontodelId
  ) => {
    const kontodelDef = this.getKontodelDefByOrdningsNr(kontoplanId, 1);

    const tillaggsinfo = kontodelDef?.kontodelar.find(
      kontodel => kontodel.id === baskontoKontodelId
    )?.tillaggsinfo;

    return tillaggsinfo ?? null;
  };

  getMomsForKontodelsDefOrdningsnr = (kontoplanId: string): number | null => {
    const kontodelsDefs = this.getKontodelDefsByKodplanId(kontoplanId);

    const kontodelsDefWithMoms = kontodelsDefs.find(
      kontodelDef => kontodelDef.anvandsForMoms
    );

    if (kontodelsDefWithMoms) {
      return kontodelsDefWithMoms.ordningsNr;
    }
    return null;
  };

  getKontodelMomspliktigOchAvdragsratt = (
    kontodel: IKontodel,
    bokfDate: Date
  ): IMomspliktig => {
    const nuvMomspliktFran =
      kontodel?.nuvMomspliktFran != null
        ? new Date(kontodel.nuvMomspliktFran)
        : null;
    const nuvMomspliktTill =
      kontodel?.nuvMomspliktTill != null
        ? new Date(kontodel.nuvMomspliktTill)
        : null;
    const foregMomspliktFran =
      kontodel?.foregMomspliktFran != null
        ? new Date(kontodel.foregMomspliktFran)
        : null;
    const foregMomspliktTill =
      kontodel?.foregMomspliktTill != null
        ? new Date(kontodel.foregMomspliktTill)
        : null;
    const foregForegMomspliktFran =
      kontodel?.foregForegMomspliktFran != null
        ? new Date(kontodel.foregForegMomspliktFran)
        : null;
    const foregForegMomspliktTill =
      kontodel?.foregForegMomspliktTill != null
        ? new Date(kontodel.foregForegMomspliktTill)
        : null;

    if (
      nuvMomspliktFran &&
      nuvMomspliktTill &&
      nuvMomspliktFran <= bokfDate &&
      bokfDate <= nuvMomspliktTill
    ) {
      //Ligger i nuvarande period
      return {
        isMomspliktig: true,
        avdragsratt: kontodel?.nuvMomspliktProcent ?? null,
      };
    } else if (
      foregMomspliktFran &&
      foregMomspliktTill &&
      foregMomspliktFran <= bokfDate &&
      bokfDate <= foregMomspliktTill
    ) {
      {
        //Ligger i förgående period
        return {
          isMomspliktig: true,
          avdragsratt: kontodel?.foregMomspliktProcent ?? null,
        };
      }
    } else if (
      foregForegMomspliktFran &&
      foregForegMomspliktTill &&
      foregForegMomspliktFran <= bokfDate &&
      bokfDate <= foregForegMomspliktTill
    ) {
      //Ligger i förgående förgående period
      return {
        isMomspliktig: true,
        avdragsratt: kontodel?.foregForegMomspliktProcent ?? null,
      };
    }
    //Ligger inte i någon period
    return { isMomspliktig: false, avdragsratt: null };
  };

  isNewSelectedKontodelMomspliktig = (
    kodplanId: string,
    ordningsNr: number,
    kontodelId: string,
    bokfDate: Date,
    useObseleteGetKontodelByKontodel?: boolean
  ): boolean => {
    const kontodel = useObseleteGetKontodelByKontodel
      ? this.getKontodelByKontodel(kodplanId, ordningsNr, kontodelId, bokfDate)
      : this.getKontodelByKontodelID(
          kodplanId,
          ordningsNr,
          kontodelId,
          bokfDate
        );

    if (kontodel) {
      return this.getKontodelMomspliktigOchAvdragsratt(kontodel, bokfDate)
        .isMomspliktig;
    }
    return false;
  };

  getAvdragsratt = (
    kodplanId: string,
    ordningsNr: number,
    kontodelId: string,
    bokfDate: Date,
    radtyp: number,
    useObseleteGetKontodelByKontodel?: boolean
  ): number => {
    if (radtyp === 6) {
      //Oavsett vad vikten på koddelen ska avdragsrätten enligt verksamhetsregler för radtyp 6 alltid vara 100%
      return 1;
    }

    const kontodel = useObseleteGetKontodelByKontodel
      ? this.getKontodelByKontodel(kodplanId, ordningsNr, kontodelId, bokfDate)
      : this.getKontodelByKontodelID(
          kodplanId,
          ordningsNr,
          kontodelId,
          bokfDate
        );

    if (kontodel) {
      const momspliktigInfo = this.getKontodelMomspliktigOchAvdragsratt(
        kontodel,
        bokfDate
      );
      if (momspliktigInfo.isMomspliktig) {
        return momspliktigInfo.avdragsratt ?? 1;
      }
    }
    return 0;
  };

  getKontodelAntalRed = (
    kontoplanId: string,
    baskontoKontodelId: string
  ): IAntalredovisning => {
    const basKontodelDef = this.getKontodelDefByOrdningsNr(kontoplanId, 1);

    const antalsredovisning = basKontodelDef?.kontodelar.find(
      kontodel => kontodel.id === baskontoKontodelId
    )?.antalsRedovisning;

    const enhet = basKontodelDef?.kontodelar.find(
      kontodel => kontodel.id === baskontoKontodelId
    )?.enhet;

    return { usesAntal: antalsredovisning ?? false, unit: enhet };
  };

  getKonteringSaknasErrors = (
    kodstrang: IKodstrang,
    isMottagningsAttestant: boolean,
    konteringsForslag:
      | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All
      | undefined,
    minFakturaAttest: IAktuellFakturaAttestInfo
  ) => {
    const errors: IFieldValidation[] = [];

    if (kodstrang.kontodelar.length === 0) {
      errors.push({
        fieldName: kodstrang.id,
        message: 'Kontering saknas',
        type: isMottagningsAttestant
          ? 'Warning'
          : konteringsForslag?._Associations?.Fakturaattest?.id ===
            minFakturaAttest.aktuellFakturaAttest?.id
          ? 'Error'
          : 'Warning',
      });
    } else if (
      !kodstrang.kontodelar.find(kd => kd.ordningsNr === 1) ||
      kodstrang.kontodelar.some(
        kd => kd == null || (kd.ordningsNr === 1 && kd.id == null)
      )
    ) {
      errors.push({
        fieldName: kodstrang.id,
        message: 'Baskonto saknas',
        type: isMottagningsAttestant
          ? 'Warning'
          : konteringsForslag?._Associations?.Fakturaattest?.id ===
            minFakturaAttest.aktuellFakturaAttest?.id
          ? 'Error'
          : 'Warning',
      });
    }

    return errors;
  };

  checkKontoplan = (kodstrang: IKodstrang): IKonteringValidationError[] => {
    return kodstrang.kontodelar
      .filter(kontodel => !kontodel.id && kontodel.kontodel !== 'Saknas')
      .map(kontodel => ({
        kontodel: kontodel.kontodel,
        lopnr: kontodel.ordningsNr,
        meddelande: `Ingen träff`,
        type: 'Error',
      }));
  };

  getKombinationErrors = (
    kodstrang: IKodstrang,
    kontoplan: IKontoplan,
    bokfDate: Date,
    isMottagningsAttestant?: boolean
  ): IKonteringValidationError[] => {
    let kombinationErrors: IKonteringValidationError[] = [];
    const kontodelDefs = kontoplan.kontodelDefs;

    kodstrang.kontodelar.forEach(kodstrangDel => {
      const kontodel = this.getKontodelByKontodel(
        kontoplan.id,
        kodstrangDel.ordningsNr,
        kodstrangDel.kontodel,
        bokfDate
      );

      kombinationErrors = kombinationErrors.concat(
        kombinationValidation(
          kodstrang,
          kontoplan,
          bokfDate,
          kodstrangDel,
          kontodelDefs,
          kontodel,
          isMottagningsAttestant
        )
      );
    });
    return kombinationErrors;
  };

  getKombinationsVillkorsErrors = (
    kodstrang: IKodstrang,
    kontoplan: IKontoplan,
    bokfDate: Date,
    isMottagningsAttestant?: boolean
  ): IKonteringValidationError[] => {
    let kombinationVillkorErrors: IKonteringValidationError[] = [];
    let kombvillkorOK: boolean = true;
    const kombKoddelDefArray: IKontodelDef[] = [];
    kodstrang.kontodelar.forEach(kodstrangDel => {
      const kontodel = this.getKontodelByKontodel(
        kontoplan.id,
        kodstrangDel.ordningsNr,
        kodstrangDel.kontodel,
        bokfDate
      );

      const kontodelDef = this.getKontodelDefByOrdningsNr(
        kontoplan.id,
        kodstrangDel.ordningsNr
      );

      for (
        let kombOrdningsNr = 1;
        kombOrdningsNr <= kontoplan.kontodelDefs.length;
        kombOrdningsNr++
      ) {
        const kombKoddelDef = this.getKontodelDefByOrdningsNr(
          kontoplan.id,
          kombOrdningsNr
        );

        if (kombKoddelDef) {
          kombKoddelDefArray.push(kombKoddelDef);
        }
      }
      kombinationVillkorErrors = kombinationVillkorErrors.concat(
        kombinationsVillkorValidation(
          kodstrang,
          kontoplan,
          bokfDate,
          kodstrangDel,
          kombvillkorOK,
          kontodel,
          kontodelDef,
          kombKoddelDefArray,
          isMottagningsAttestant
        )
      );
    });

    return kombinationVillkorErrors;
  };

  getKontodelErrors = (
    kodstrang: IKodstrang,
    kontoplan: IKontoplan,
    bokfDate: Date,
    BFO: boolean
  ): IKonteringValidationError[] => {
    let kontodelErrors: IKonteringValidationError[] = [];
    const kombKoddelDefArray: IKontodelDef[] = [];
    kodstrang.kontodelar.forEach(kodstrangDel => {
      const kontodel = this.getKontodelByKontodelID(
        kontoplan.id,
        kodstrangDel.ordningsNr,
        kodstrangDel.id,
        bokfDate
      );
      for (
        let kombOrdningsNr = 1;
        kombOrdningsNr <= kontoplan.kontodelDefs.length;
        kombOrdningsNr++
      ) {
        const kombKoddelDef = this.getKontodelDefByOrdningsNr(
          kontoplan.id,
          kombOrdningsNr
        );

        if (kombKoddelDef) {
          kombKoddelDefArray.push(kombKoddelDef);
        }
      }
      kontodelErrors = kontodelErrors.concat(
        kontodelValidation(kodstrangDel, kontodel, BFO)
      );
    });

    return kontodelErrors;
  };

  getKodbehErrors = (
    kontoplan: IKontoplan | null,
    kodstrang: IKodstrang,
    konteringsforslagWithKodBeh: IFilteredKodbehForKonteringsForslag[],
    isMottagningsAttestant: boolean,
    requireMotKodbeh: boolean,
    minFakturaAttest: IAktuellFakturaAttestInfo
  ): IKonteringValidationError[] => {
    let result: IKonteringValidationError[] = [];

    if (kontoplan) {
      const correctKonteringsForslag = konteringsforslagWithKodBeh.find(kf => {
        return kf.konteringsforslagID === kodstrang.id;
      });

      let kodbehorigheter =
        correctKonteringsForslag?.attestkodbehorigheter ?? [];

      // Finns det inga ok kodbeh så tar vi den som är mest ok enligt sin correctnessCount
      let useCorrectnessKodbehErrorMsg = '';
      if (kodbehorigheter.length === 0) {
        kodbehorigheter = correctKonteringsForslag?.correctnessKodbeh ?? [];
        if (correctKonteringsForslag?.correctnessKodbeh?.length === 1) {
          useCorrectnessKodbehErrorMsg = `Utanför kodbehörighet ${correctKonteringsForslag?.correctnessKodbeh[0]?.urval?.savedUrvalProps?.namn}`;
        } else {
          useCorrectnessKodbehErrorMsg = 'Utanför dina kodbehörigheter';
        }
      }

      // Har vi inget krav på att MA ska ha kodbeh så ger vi MA en kodbeh om den inte skulle haft en
      if (!requireMotKodbeh && kodbehorigheter.length === 0) {
        kodbehorigheter = createTemplateWholeBookKodbeh(
          minFakturaAttest,
          kontoplan.id
        );
      }

      if (kodbehorigheter.length !== 0) {
        for (let i = 0; i < kodbehorigheter.length; i++) {
          const errors = kontostrangInSelection(
            kontoplan,
            kodstrang.kontodelar,
            kodbehorigheter[i].urval,
            false // Blank ska alltid generera ett fel/varning
          );

          if (errors) {
            const errorMeddelande =
              useCorrectnessKodbehErrorMsg === ''
                ? `Utanför kodbehörighet ${kodbehorigheter[i].urval?.savedUrvalProps?.namn}`
                : useCorrectnessKodbehErrorMsg;

            if (errors.length === 0) {
              result = [];
              break;
            } else {
              result = result.concat(
                errors.map((e): IKonteringValidationError => {
                  return {
                    kontodel: e.values[0],
                    lopnr: parseInt(e.name.slice(-1), 10),
                    meddelande:
                      e.errorType === UrvalErrorEnum.SaknarVarde
                        ? `Måste anges enligt din kodbehörighet ${kodbehorigheter[i].urval?.savedUrvalProps?.namn}`
                        : errorMeddelande,
                    type: isMottagningsAttestant
                      ? requireMotKodbeh &&
                        !(e.errorType === UrvalErrorEnum.SaknarVarde)
                        ? 'Error'
                        : 'Warning'
                      : 'Error',
                  };
                })
              );
            }
          }
        }
      } else {
        kodstrang.kontodelar.map(koddel => {
          const error: IKonteringValidationError = {
            kontodel: '',
            lopnr: koddel.ordningsNr,
            meddelande: 'Utanför dina kodbehörigheter',
            type: isMottagningsAttestant
              ? requireMotKodbeh
                ? 'Error'
                : 'Warning'
              : 'Error',
          };

          result.push(error);
        });
      }
    } else {
      const error: IKonteringValidationError = {
        kontodel: '',
        lopnr: -1,
        meddelande: 'Kodplan saknas',
        type: 'Error',
      };
      result.push(error);
    }
    return result;
  };

  isAttesteradByBeslutAttestant = (
    konteringForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
    otherBeslutAttestanter?: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[]
  ): boolean => {
    let result = false;
    if (otherBeslutAttestanter) {
      result = otherBeslutAttestanter.some(beslutAttestant => {
        return (
          beslutAttestant._Associations?.Attestratt?.id ===
            konteringForslag._Associations?.Fakturaattest?._Associations
              ?.Attestratt?.id &&
          beslutAttestant.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD
        );
      });
    }
    return result;
  };

  getBeloppFromFilledKonteringsForslag = (
    konteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[],
    otherBeslutAttestanter?: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[]
  ): number => {
    let totalBelopp = 0;
    for (let index = 0; index < konteringsForslag.length; index++) {
      const kontering = konteringsForslag[index];

      //Skippa autoadded konteringar som ej är tagen av den inloggade användaren
      if (
        (kontering.id.includes(AUTOMATICALLY_ADDED_VALUE_PREFIX) &&
          otherBeslutAttestanter) ||
        (otherBeslutAttestanter &&
          !this.isAttesteradByBeslutAttestant(
            kontering,
            otherBeslutAttestanter
          ))
      ) {
        continue;
      }
      totalBelopp += kontering.DEBET - kontering.KREDIT;
    }
    return totalBelopp;
  };

  getBeslutsattestantMissingError = (
    konteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[]
  ) => {
    let result: IFieldValidation[] = [];

    konteringsForslag.forEach(kf => {
      if (!kf._Associations?.Fakturaattest?.id) {
        const error: IFieldValidation = {
          fieldName: kf.id + ' ' + 'attestant',
          message: 'Beslutsattestant saknas',
          type: 'Warning',
        };

        result.push(error);
      }
    });

    return result;
  };

  getMoreKonteringsraderErrors = (
    otherBeslutAttestanter: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Fakturadel__Associations_Fakturaattest[],
    myKonteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[],
    othersKonteringsForslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All[],
    fakturaBelopp: number
  ): IKonteringValidationError[] => {
    const result: IKonteringValidationError[] = [];

    const otherKonteringForslagsBelopp =
      this.getBeloppFromFilledKonteringsForslag(
        othersKonteringsForslag,
        otherBeslutAttestanter
      );

    const myKonteringsforslagBelopp =
      this.getBeloppFromFilledKonteringsForslag(myKonteringsForslag);

    const remainingBelopp = roundToTwoDecimals(
      fakturaBelopp - otherKonteringForslagsBelopp - myKonteringsforslagBelopp
    );

    const remainingAttestanterWithUtdeladStatus = otherBeslutAttestanter.some(
      beslutAttestant =>
        beslutAttestant.STATUS === TEDLRFakturaAttestSTATUSEnum.UTDELAD
    );

    const othersKonteringsForslagWithoutAttest = othersKonteringsForslag.filter(
      konteringsforslag => {
        const kfAttstantId = konteringsforslag._Associations?.Fakturaattest?.id;
        if (kfAttstantId) {
          const foundBA = otherBeslutAttestanter.find(
            otherBeslutAttestant =>
              otherBeslutAttestant.id === kfAttstantId &&
              otherBeslutAttestant.STATUS !==
                TEDLRFakturaAttestSTATUSEnum.ATTESTERAD
          );
          return Boolean(foundBA);
        } else {
          return true;
        }
      }
    );

    if (remainingBelopp !== 0 && !remainingAttestanterWithUtdeladStatus) {
      othersKonteringsForslagWithoutAttest.forEach(konteringsforslag => {
        const error: IKonteringValidationError = {
          kontodel: konteringsforslag.id + ' ' + BELOPP_FIELD_NAME,
          lopnr: -1,
          meddelande: 'Du behöver attestera resten av beloppet',
          type: 'Error',
        };

        result.push(error);
      });
    } else if (remainingBelopp === 0 && remainingAttestanterWithUtdeladStatus) {
      myKonteringsForslag.forEach(konteringsforslag => {
        const error: IKonteringValidationError = {
          kontodel: konteringsforslag.id + ' ' + BELOPP_FIELD_NAME,
          lopnr: -1,
          meddelande: 'Du kan inte attestera hela beloppet',
          type: 'Error',
        };
        result.push(error);
      });
    } else if (myKonteringsforslagBelopp === 0) {
      othersKonteringsForslagWithoutAttest.forEach(konteringsforslag => {
        const error: IKonteringValidationError = {
          kontodel: konteringsforslag.id + ' ' + BELOPP_FIELD_NAME,
          lopnr: -1,
          meddelande: 'Du behöver attestera en del av beloppet',
          type: 'Error',
        };
        result.push(error);
      });
    }
    return result;
  };

  getBeloppErrors = (
    konteratBelopp: number,
    fakturaBelopp: number,
    kodstrang: IKodstrang,
    isMottagningsAttestant: boolean
  ): IKonteringValidationError[] => {
    const result: IKonteringValidationError[] =
      konteratBelopp === fakturaBelopp
        ? []
        : konteratBelopp > fakturaBelopp
        ? [
            {
              kontodel: BELOPP_FIELD_NAME,
              lopnr: -1,
              meddelande: 'Attesterat belopp får ej överstiga fakturabelopp',
              type: 'Error',
            },
          ]
        : [
            {
              kontodel: BELOPP_FIELD_NAME,
              lopnr: -1,
              meddelande: 'Hela fakturabeloppet behöver attesteras',
              type: 'Error',
            },
          ];

    if (kodstrang.belopp === 0) {
      result.push({
        kontodel: kodstrang.id + ' ' + BELOPP_FIELD_NAME,
        lopnr: -1,
        meddelande: 'Belopp får ej vara 0',
        type: isMottagningsAttestant ? 'Warning' : 'Error',
      });
    }

    const currentKodbeh = this.konteringsForslagWithKodbeh.find(
      kodbeh => kodbeh.konteringsforslagID === kodstrang.id
    );

    if (kodstrang.kontodelar.length > 0 && currentKodbeh) {
      const currentCorrectnessKodbeh = findKodbehWithHighestMaxbelopp(
        currentKodbeh?.correctnessKodbeh
      );
      if (!isMottagningsAttestant) {
        if (currentCorrectnessKodbeh?.maxbelopp != null) {
          if (kodstrang.belopp > currentCorrectnessKodbeh.maxbelopp) {
            result.push({
              kontodel: kodstrang.id + ' ' + BELOPP_FIELD_NAME,
              lopnr: -1,
              meddelande: `Du får inte attestera belopp över ${findFormatter(
                'TEDFormatCurr'
              ).displayer.display(
                currentCorrectnessKodbeh.maxbelopp,
                true
              )} enligt kodbehörighet ${
                currentCorrectnessKodbeh.urval.savedUrvalProps?.namn
              }`,
              type: isMottagningsAttestant ? 'Warning' : 'Error',
            });
          }
        }
      }
    }

    return result;
  };

  getTillaggsinfoAvskrivningKontodelOrdningsnummerList = (
    bokfDatum: Date
  ): number[] => {
    const konteringsvardeList = this.konteringsvarden.filter(
      konteringsvarde =>
        (!konteringsvarde.FROM_DATUM ||
          new Date(konteringsvarde.FROM_DATUM) <= bokfDatum) &&
        (!konteringsvarde.TOM_DATUM ||
          new Date(konteringsvarde.TOM_DATUM) >= bokfDatum)
    );

    const kontodelkombinationList = this.kontodelkombinationer
      .filter(
        kontodelkombination =>
          (kontodelkombination.KOMBINATION ===
            TEDEKKontodelkombinationKOMBINATIONEnum.MASTE_KOMBINERAS ||
            kontodelkombination.LOKALT_KRAV) &&
          konteringsvardeList?.some(
            konteringsvarde =>
              konteringsvarde._Associations?.Kontodel1?.id ===
              kontodelkombination._Associations?.Kontodel.id
          ) &&
          (!kontodelkombination._Associations?.Kontodel.FRAN_DATUM ||
            new Date(kontodelkombination._Associations?.Kontodel.FRAN_DATUM) <=
              bokfDatum) &&
          (!kontodelkombination._Associations?.Kontodel.TILL_DATUM ||
            new Date(kontodelkombination._Associations?.Kontodel.TILL_DATUM) >=
              bokfDatum)
      )
      .map(kontodelkombination => kontodelkombination.KOMB_ORDNINGS_NR);

    const avskrivningskontoOrdningsnummerList = kontodelkombinationList
      ? uniq(kontodelkombinationList)
      : [];

    return avskrivningskontoOrdningsnummerList;
  };
}
